import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { formatImgUrl } from "../../../../utils/cardFormating";
import WorldMapLocations from "../../../../shared/WorldMapLocations";
import { Country } from "../../../../types";

const CandidatesLocations = ({
  countries,
  isCountriesLoading,
}: {
  countries: Country[];
  isCountriesLoading: boolean;
}) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.previewAndPublishJob" });

  const MapLocations = countries.map(({ name, lat, lng }) => ({
    country: name,
    coordinates: [Number(lat), Number(lng)] as [number, number],
  }));

  if (isCountriesLoading) {
    return (
      <Box component="section" sx={styles.container}>
        <Box sx={styles.titleContainer}>
          <Typography sx={styles.title}>{t("thePerfectCandidateShouldBeFrom")}</Typography>
          <Box sx={styles.flagsContainer}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Box key={index} sx={styles.country}>
                <Skeleton variant="rounded" width={20} height={20} />
                <Skeleton variant="text" width={100} height={30} />
              </Box>
            ))}
          </Box>
        </Box>
        <WorldMapLocations countries={MapLocations} />
      </Box>
    );
  }

  return (
    <Box component="section" sx={styles.container}>
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.title}>{t("thePerfectCandidateShouldBeFrom")}</Typography>
        <Box sx={styles.flagsContainer}>
          {countries.map(({ name, url }) => (
            <Box key={name} sx={styles.country}>
              <Box component="img" src={formatImgUrl(url)} sx={styles.flag} alt={name} />
              <Typography>{name}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <WorldMapLocations countries={MapLocations} />
    </Box>
  );
};

export default CandidatesLocations;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  flag: {
    width: "20px",
    height: "20px",
  },
  flagsContainer: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
  },
  country: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
};
